
const CustomVioletButton = ({ onClick, isLoading, btnLabel }:any) => {
    return (
      <button
        type="submit"
        className={`btn btn-violet ${isLoading ? "btn-disabled p-3" : ""}`}
        onClick={onClick}
        disabled={isLoading}
        style={{  height: isLoading ? '50px' : 'auto'}}
      >
        {btnLabel}
      </button>
    );
  };
  
  export default CustomVioletButton;
  